import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { RootState } from '@reducers/index';
import { gameProviderTypes } from '@configs/layout';
import { integerFormatter } from '@utils/common/formatter';

type publisher = {
  developer: string;
  provider_type: string;
  numberOfApps: number;
  activeCategories: number;
};

const PublisherInfo = () => {
  const { publisherInfo } = useSelector(({ app }: RootState) => app);

  const [infoObj, setInfoObj] = useState<publisher | null>(null);

  useEffect(() => {
    if (!!publisherInfo) {
      console.log('publisherInfo: ', publisherInfo);
      const { developer, provider_type } = publisherInfo[0];
      const appNum = publisherInfo?.length;
      let categories = [];
      publisherInfo.forEach((item) => {
        categories.push(...item.genres);
      });
      const appCategories = [...Array.from(new Set(categories))];

      setInfoObj({
        developer: developer ?? '',
        provider_type: provider_type,
        numberOfApps: appNum,
        activeCategories: appCategories.length,
      });
    }
  }, [publisherInfo]);

  return (
    <>
      {infoObj && (
        <>
          <div className="app-name">
            <div className="app-name-txt">
              <h2 className="app-name-tit">{infoObj?.developer}</h2>
            </div>
          </div>
          <div className="app-category">
            <div className="app-category-img">
              <button
                type="button"
                className={`btn-ico-single ${
                  infoObj?.provider_type === gameProviderTypes.AppleAppStore ? 'app' : 'google'
                } `}
              >
                <span className="blind">{infoObj?.provider_type}</span>
              </button>
            </div>
          </div>
          <div className="app-score">
            <span className="app-score-tit">Number Of Apps</span>
            <div>
              <span className="app-score-tit">{integerFormatter(infoObj?.numberOfApps)}</span>
            </div>
          </div>
          <div className="app-score">
            <span className="app-score-tit">Active Categories</span>
            <div>
              <span className="app-score-tit">{integerFormatter(infoObj?.activeCategories)}</span>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PublisherInfo;
